import styled from 'styled-components';
import { theme } from '../../../global';

export const CaseLinksContainer = styled.div`
  display: flex;
  gap: ${theme.spacings.s4};
  align-items: center;
  flex-wrap: wrap;
`;

export const Item = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

export const Description = styled.span`
  font-family: 'Montserrat';
  font-weight: 400;
  line-height: 100%;
  letter-spacing: 0%;
  font-size: 14px;
  color: ${theme.colors.secondaryText};
`;

export const Name = styled.span`
  font-family: 'Montserrat';
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  color: ${theme.colors.primaryText};
`;
